<template>
  <div class="site-footer">
    <div class="container">
     
      <div class="footer-links clearfix" style="display: flex;">
		  <div style="width: 80%;">
	<!-- qecode  -->
	<div style="height: 100px;">
	  <img style="width: 100px;height: 100px" src="../../../assets/imgs/wx-img.jpg" alt="" >
	</div>
			<!-- info  start -->
	
      <div class="logo ir"></div>
      <div class="info-text">
        <p class="sites">
          <a href="http://www.zondarchina.com" >星中德汽车连锁</a>
          <span class="sep">|</span>
          <a href="" >杭州车管家数字科技</a>
          <span class="sep">|</span>
          <a href="" >绿城车管家</a>
          <span class="sep">|</span>
          <a href="" >幸福车生活</a>
          <span class="sep">|</span>
          <a href="" >车修修隐私政策</a>
          <span class="sep">|</span>
          <a href="" >车修修用户协议</a>
        </p>
        <p>
            ©
            <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=浙ICP备16033624号" target="_blank"  title="" stat_exposure="true"></a>浙ICP备16033624号
            
        </p>
      </div>
    </div>
	<!-- info  end -->
        <div class="col-contact">
          <p class="phone">400-6758-188</p>
          <p>8:00-18:00</p>
          <a href="" class="btn btn-line-primary btn-small J_contactBtn">
            <em class="iconfont-message2"></em>人工客服
          </a>
          
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
export default {
  name: 'Footer',
  data(){
    return{
      isOverWX: false
    }
  },
  methods: {
    showImg(){
      this.isOverWX = true
    },
    hideImg(){
      this.isOverWX = false
    }
  }
}
</script>

<style lang="less" scoped>
.site-footer{
  background-color: #fff;
}
.container {
  width: 1226px;
  margin-right: auto;
  margin-left: auto;
  .footer-service{
    padding: 27px 0;
    border-bottom: 1px solid #e0e0e0;
    .list-service{
      margin: 0;
      padding: 0;
      list-style-type: none;
      li{
        float: left;
        width: 19.8%;
        height: 25px;
        border-left: 1px solid #e0e0e0;
        font-size: 14px;
        line-height: 25px;
        text-align: center;
        a{
        color: #616161;
        -webkit-transition: color .2s;
        transition: color .2s;
        background-color: rgba(0,0,0,0);
        .iconfont{
          margin-right: 6px;
          font-size: 24px;
          line-height: 24px;
          vertical-align: -4px;
        }
      }
      a:hover{
        color: #f6700f;
      }
      }
      
    }
  }
}
.container:after, .container:before {
    content: " ";
    display: table;
}
.container:after {
    clear: both;
}
.site-footer .list-service li:first-child {
    border-left: 0;
}

// 下面的信息
.site-footer .footer-links {
  padding: 40px 0;
   .col-links {
    float: left;
    width: 160px;
    margin: 0;
    dt{
      margin: -1px 0 26px;
      font-size: 14px;
      line-height: 1.25;
      color: #424242;
      display: block;
      dd{
        margin: 10px 0 0;
        font-size: 10px;
        a{
          color: #757575;
          display: inline;
        }
        a:hover{
          color: #f6700f;
        }
      }
    }
    
  }
}
.col-contact {
      float: right;
      width: 251px;
      border-left: 1px solid #e0e0e0;
      text-align: center;
      color: #616161;
      .phone{
        font-size: 22px;
        line-height: 1;
        color: #ff6700;
      }
      p{
        margin: 0 0 5px 0;
        font-size: 12px;
      }
      .btn-line-primary {
        border:1px solid #ff6700;
        background: #fff;
        color: #ff6700;
        width: 118px;
        height: 28px;
        display: inline-block;
        padding: 0px;
        margin: 0;
        // border: 1px solid #b0b0b0;
        font-size: 14px;
        line-height: 28px;
        text-align: center;
        cursor: pointer;
        -webkit-transition: all .4s;
        transition: all .4s;
      }
      .btn:hover{
        color: #fff;
        background: #ff6700;
      }
       .follow {
        font-size: 12px;
        margin-top: 10px;
        position: relative;
        a{
          width: 24px;
          height: 24px;
          display: inline-block;
          vertical-align: middle;
          margin-left: 6px;
          margin-top: -3px;
        }
        .wb{
          background: url(https://cdn.cnbj1.fds.api.mi-img.com/staticsfile/global/wb.png) 50% 0 no-repeat;
          background-size: cover;
        }
        .wx {
          background: url(https://cdn.cnbj1.fds.api.mi-img.com/staticsfile/global/wx.png) 50% 0 no-repeat;
          background-size: cover;
        }
        img{
          width: 126px;
          height: 126px;
          z-index: 2;
          position: absolute;
          top: 20px;
          left: 100px;
        }
      }
    }
	
</style>